import { api_create_message_path } from '../../routes';
import { SuccessResponse } from '../interfaces';
import request from './request';

export async function createMessage(userId: number, message: string): Promise<SuccessResponse> {
  const res = await request('post', api_create_message_path(), { user_id: userId, message });
  return res;
}
